import dayjs from 'dayjs'
export default [
  {
    type: 'datepicker',
    placeholder: '',
    filed: 'daterange',
    label: '',
    pickerType: 'datetimerange',
    valueFormat: 'yyyy-MM-dd HH:mm',
    format: 'yyyy-MM-dd HH:mm',
    default: [
      dayjs()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm'),
      dayjs().format('YYYY-MM-DD HH:mm')
    ]
  }
]
